import React from "react";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  drawImageWithAspect,
  generateWatermakedCanvasImage,
  getImageBitmap,
} from "../../../utils/canvas";
import demoProgressPhoto from "../../../assets/demo-progress-photo.png";
import watermark from "../../app/logo-full-mono.png";
import { useCurrentWorkspace } from "../../../hooks/useCurrentWorkspace";

const useStyles = makeStyles((theme) => ({
  sharablePreview: {
    justifySelf: "center",
    alignSelf: "center",
    aspectRatio: "1/1",
    borderRadius: theme.shape.borderRadius * 2,
    overflow: "hidden",
    border: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(1),
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  sharablePreviewContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: theme.spacing(52),
    borderColor: theme.palette.divider,
    borderWidth: theme.spacing(0.5),
    borderRadius: theme.spacing(2),
    padding: theme.spacing(0, 1),
  },
  sharablePreviewTitle: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
}));

interface SharablePreviewCanvasProps {
  brandedAppBanner?: string;
  backgroundUrl?: string;
  title?: string;
}

export function SharablePreviewCanvas({
  brandedAppBanner,
  backgroundUrl,
  title,
}: SharablePreviewCanvasProps) {
  const s = useStyles();
  const canvasRef = React.useRef<HTMLCanvasElement>(null);

  const { logoUrl: workspaceLogoUrl } = useCurrentWorkspace();

  React.useEffect(() => {
    const generateCanvas = async () => {
      if (canvasRef.current) {
        await generateWatermakedCanvasImage(
          drawImageWithAspect(
            await getImageBitmap(backgroundUrl || demoProgressPhoto),
            1,
          ),
          canvasRef,
          brandedAppBanner || workspaceLogoUrl,
        );
      }
    };
    generateCanvas();
  }, [brandedAppBanner, backgroundUrl]);

  return (
    <Box className={s.sharablePreviewContainer}>
      <Box className={s.sharablePreview}>
        <canvas
          ref={canvasRef}
          width="1000"
          height="1000"
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "transparent",
          }}
        />
      </Box>
      <Typography
        className={s.sharablePreviewTitle}
        variant="h6"
        textAlign="center"
      >
        {title || "Progress Sharing Preview"}
      </Typography>
    </Box>
  );
}
